import { pnCollectionPage } from './PNCollectionPage/reducers';
import { pnGtmEnhancedEcom } from './PNGtmEnhancedEcom/reducers';

export const addonReducers = {
    ...pnCollectionPage,
    ...pnGtmEnhancedEcom,
};
